import useUserTier from "../../../hooks/useUserTier";
import { useState } from "react";
import DiscountProcessModal from "./DiscountProcessModal";
import useGeoLocation from "../../../hooks/useGeolocation";
import { message, Modal } from "antd";
import { isMobile, isTablet } from "react-device-detect";
import { useSelector } from "react-redux";

function RegionalDiscountButton({
  className = "",
  style = {},
  title = "",
  icon,
}) {
  const {
    main: { userData },
  } = useSelector((state) => state);

  const { isVerified, tier, country } = useUserTier();

  const [showDiscountModal, setShowDiscountModal] = useState(false);

  const { canTry } = useUserTier();

  const { getLocation } = useGeoLocation();

  const clickHandler = (e) => {
    e.stopPropagation();
    const isTestUser = userData?.email === "991fe98e91@emaildbox.pro";
    console.log(isTestUser);

    if (userData?.email === "sami.pawl@gmail.com") {
      return setShowDiscountModal(true);
    }
    if (!canTry && !isTestUser) {
      return Modal.info({
        title: "Your location already has been verified! You can retry later.",
        centered: true,
      });
    }
    if (isMobile || isTablet || isTestUser) {
      getLocation();
    } else {
      setShowDiscountModal(true);
    }
  };

  return (
    <>
      <div onClick={clickHandler} className={className} style={style}>
        {icon && icon}
        {title || "Regional Offer"}
      </div>

      {showDiscountModal && (
        <DiscountProcessModal
          show={showDiscountModal}
          setShow={setShowDiscountModal}
          // type={!isMobile || !isTablet ? "process" : "alert"}
          type="alert"
        />
      )}
    </>
  );
}

export default RegionalDiscountButton;
